class ServiceError extends Error {
  constructor(message, data = {}) {
    super();
    this.message = message;
    this.name = this.constructor.name;
    this.data = data;
  }
}

export default ServiceError;
